import { render, staticRenderFns } from "./rewards-subscribe-to-sms.vue?vue&type=template&id=cb72b144&scoped=true&"
import script from "./rewards-subscribe-to-sms.vue?vue&type=script&lang=js&"
export * from "./rewards-subscribe-to-sms.vue?vue&type=script&lang=js&"
import style0 from "./rewards-subscribe-to-sms.vue?vue&type=style&index=0&id=cb72b144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb72b144",
  null
  
)

export default component.exports